export const buildInfo = {
  lastBuildDate: '2026-11-05T15:35:37.924Z',
};
